import React, { useContext } from 'react';
import { Typography } from 'antd';
import SearchContext from '../../../context';
import { Row, Col } from 'react-flexbox-grid';
import react from '../../../assets/tools/react.png';
import angular from '../../../assets/tools/angular.png';
import js from '../../../assets/tools/js.png';
import ts from '../../../assets/tools/typescript.png';
import ionic from '../../../assets/tools/ionic.png';
import cordova from '../../../assets/tools/cordova.jpeg';
import redux from '../../../assets/tools/redux.png';
import socket from '../../../assets/tools/socket.png';
import css from '../../../assets/tools/css.png';
import sass from '../../../assets/tools/sass.png';
import emotion from '../../../assets/tools/emotion.png';
import styled from '../../../assets/tools/styled.png';
import tailwind from '../../../assets/tools/tailwind.png';
import rest from '../../../assets/tools/rest.png';
import webpack from '../../../assets/tools/webpack.png';
import git from '../../../assets/tools/git.png';
import ci from '../../../assets/tools/ci.png';
import expo from '../../../assets/tools/expo.png';
import rxjs from '../../../assets/tools/rsjs.svg';
import jwt from '../../../assets/tools/jwt.png';
import jest from '../../../assets/tools/jest.png';
import visual from '../../../assets/tools/vc.png';
import atom from '../../../assets/tools/atom.png';
import wordpress from '../../../assets/tools/wordpress.png';
import shopify from '../../../assets/tools/shopify.png';
import LangContext from '../../../context/LangContext';

const Tools = () => {

    const contextService = useContext(SearchContext);

    const { currentLangData } = useContext(LangContext);

    const { Title } = Typography;

    const techs = [
        {title: 'React', logo: react}, {title: 'Angular', logo: angular}, {title: 'Javascript', logo: js},
        {title: 'Typescript', logo: ts}, {title: 'React Native', logo: react}, {title: 'Ionic', logo: ionic},
        {title: 'Cordova', logo: cordova}, {title: 'Redux', logo: redux}, {title: 'Socket.io', logo: socket}, 
        {title: 'CSS', logo: css},{title: 'SASS', logo: sass}, {title: 'Tailwind', logo: tailwind}, 
        {title: 'Emotion', logo: emotion}, {title: 'Styled Components', logo: styled}, {title: 'API REST', logo: rest}, 
        {title: 'Webpack', logo: webpack}, {title: 'GIT', logo: git}, {title: 'CI/CD', logo: ci}, 
        {title: 'Expo', logo: expo}, {title: 'RxJs', logo: rxjs}, {title: 'JWT', logo: jwt}, 
        {title: 'Jest', logo: jest}, {title: 'Visual Studio', logo: visual}, {title: 'Atom', logo: atom}, 
        {title: 'Wordpress', logo: wordpress}, {title: 'Shopify', logo: shopify}
    ];

    return(
        <div id="tools" className="tools-container main-container" style={{ paddingTop: '4rem', paddingBottom: '6rem', width: '100%', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
            <div style={{ maxWidth: '48rem', height: 'auto', padding: '2rem 0rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column' }} >
                <Title className="main-title-color" style={{ paddingBottom: '.45em', fontSize: '2.55rem', textAlign: 'center' }}>
                    {currentLangData.HERRAMIENTAS.title}
                </Title>
                <span className="montserrat secondary-title-color" style={{ fontSize: '1.3rem', textAlign: 'center' }} >
                    {currentLangData.HERRAMIENTAS.subtitle}
                </span>
            </div>
            <Row className="no-margin" style={{ width: '100%', height: 'auto', marginTop: '1.75em', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', flexFlow: 'wrap' }} >
                {
                    techs.map((item, i) => {
                        return(
                            <Col className="card-tools" key={i} xs={4} sm={4} md={3} lg={2} style={{ padding: '1em', marginRight: 10, height: contextService.width <= 569 ? '14vh' : '18vh', minHeight: contextService.width <= 569 ? '12vh' : '18vh', marginBottom: contextService.width <= 767 ? '1em' : '1em', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}  >
                                <img src={item.logo} alt={item.logo} style={{ width: 35 }} />
                                <span className="main-title-color montserrat" style={{ paddingTop: '.75em', fontSize: '1.15em', textAlign: 'center' }} >{item.title}</span>
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    )
}

export default Tools